import type { QueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/shared/query';

/**
 * Refetch patient lists and detail caches after local mutation or
 * `patient.changed` realtime signals.
 */
export function invalidatePatients(queryClient: QueryClient): Promise<void> {
  return queryClient
    .invalidateQueries({ queryKey: queryKeys.patient.all })
    .then(() => undefined);
}
